import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/gopath/src/github.com/rumblefrog/source-chat-relay/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "bot-commands"
    }}>{`Bot-Commands`}</h1>
    <p>{`Available bot commands`}</p>
    <h2 {...{
      "id": "rentities"
    }}>{`r/entities`}</h2>
    <p>{`Outputs the list of all entities`}</p>
    <h2 {...{
      "id": "rreceivechannel-textchannelentityid-channel"
    }}>{`r/receivechannel #TextChannel/EntityID Channel`}</h2>
    <p>{`Sets the receive channels of the entity`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Argument`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Note`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`#TextChannel/EntityID`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`❌`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Supply either a text channel mention or an entity ID from a game server`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Channel`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`✔`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This argument is required if you wish to set the value, otherwise if you leave this argument out, it will simply fetch it if it exist`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "rsendchannel-textchannelentityid-channel"
    }}>{`r/sendchannel #TextChannel/EntityID Channel`}</h2>
    <p>{`Sets the send receive channels of the entity`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Argument`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Note`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`#TextChannel/EntityID`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`❌`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Supply either a text channel mention or an entity ID from a game server`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Channel`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`✔`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`This argument is required if you wish to set the value, otherwise if you leave this argument out, it will simply fetch it if it exist`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "revent-name-data"
    }}>{`r/event Name Data`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Argument`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Optional`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Note`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`❌`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Name of the event to dispatch under`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Data`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}>{`❌`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Data associated with the event`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "rhelp"
    }}>{`r/help`}</h2>
    <p>{`Output the version, stats, and author info`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      